import { MessageSquare } from 'lucide-react';
import moment from 'moment';
import { useState } from 'react';
import { EventObservationModel } from '../../models/Evento';
import { PlusButton } from 'shared/components/IconButtons';
import { inputClass } from 'shared/theme/colorTokens';

interface Props {
  observations: EventObservationModel[];
  isSaving: boolean;
  onAdd: (observation: string) => void;
}

const EventoObservationsSection = ({
  observations,
  isSaving,
  onAdd
}: Props) => {
  const [text, setText] = useState('');
  const sorted = [...observations].sort((a, b) =>
    a.createdAt < b.createdAt ? 1 : -1
  );

  const handleAdd = () => {
    const trimmed = text.trim();
    if (!trimmed) {
      return;
    }
    onAdd(trimmed);
    setText('');
  };

  return (
    <div className="rounded-2xl border border-white bg-whiteLight p-6 dark:border-white/10 dark:bg-darkLight">
      <div className="mb-4 flex items-center gap-2">
        <MessageSquare size={18} className="text-secondary-500" />
        <h2 className="text-lg font-semibold text-ink dark:text-ink-dark">
          Observaciones
        </h2>
        <span className="rounded-full bg-secondary-50 px-2.5 py-0.5 text-xs font-medium text-secondary-700 dark:bg-white/10 dark:text-secondary-200">
          {observations.length}
        </span>
      </div>

      <div className="mb-5 flex gap-2">
        <textarea
          value={text}
          onChange={(event) => setText(event.target.value)}
          rows={2}
          placeholder="Agregar una observación..."
          className={inputClass}
        />
        <PlusButton size={24} disabled={!text.trim() || isSaving} onClick={handleAdd} />
      </div>

      <div className="flex flex-col gap-4">
        {sorted.length === 0 && (
          <p className="text-sm text-inkMuted dark:text-inkMuted-dark">
            Todavía no hay observaciones.
          </p>
        )}
        {sorted.map((observation) => (
          <div
            key={observation.id}
            className="border-l-2 border-secondary-200 pl-3 dark:border-white/10"
          >
            <p className="text-sm text-ink dark:text-ink-dark">
              {observation.observation}
            </p>
            <p className="text-xs text-inkMuted dark:text-inkMuted-dark">
              {observation.user?.name ?? 'Usuario'} ·{' '}
              {moment(observation.createdAt).format('DD MMM YYYY HH:mm')}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventoObservationsSection;
